module.exports = __webpack_public_path__ + "static/media/TFA Training-Spanish June 21 2012.97611fc7.pps";